/*
 * @Author: lidan
 * @Date: 2020-11-17 17:07:39
 * @LastEditTime: 2021-02-02 09:37:20
 * @LastEditors: lidan
 * @Description: 司机档案api
 * @FilePath: \e6-module-base-data\src\e6-module-base-data\api\drivers.js
 */
import http from "e6-base-core/axios/config";
import { e6ModuleBaseDataApi } from "@/config/api";
const {
  host = "",
  E6_MS_TMS_E6YUN_BASE_WEB = "",
  E6_MS_TMS_BASE_WEB = ""
} = e6ModuleBaseDataApi;

//********************* 司机档案 ****************** */

//获取司机档案列表数据
export function listDriversByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/drivers/listDriversByPage`,
    method: "post",
    data
  });
}
//新增司机档案信息
export function saveDriver(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/drivers/saveDriver`,
    method: "post",
    data
  });
}
//修改司机档案信息
export function updateDriver(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/drivers/updateDriver`,
    method: "post",
    data
  });
}

//查询司机档案详细信息
export function getDriverById(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/drivers/getDriverById`,
    method: "get",
    params
  });
}
//删除司机档案信息
export function deleteDrivers(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/drivers/deleteDrivers`,
    method: "post",
    data
  });
}

//联系电话/身份证号重复性校验
export function validateDriverField(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/drivers/validateDriverField`,
    method: "post",
    data
  });
}

//司机导出信息
export function exportDrivers(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/drivers/exportDrivers`,
    method: "post",
    data
  });
}

//(下拉框)查询全部的承运商信息
export function findAllCarrierByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/findAllCarrierByPage`,
    method: "post",
    data
  });
}

//(下拉框)查询所属部门信息
export function findOrganizationTree() {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/e6Organization/findOrganizationTree`,
    method: "get"
  });
}

//司机档案重置密码
export function resetPassword(params) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/drivers/resetPassword`,
    method: "get",
    params
  });
}
//开通司机账号
export function openDriverAccount(data) {
  return http({
    url: `${host}${E6_MS_TMS_E6YUN_BASE_WEB}/drivers/openDriverAccount`,
    method: "post",
    data
  });
}
